
import React, { useState, useEffect } from 'react';
import { MapPin } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useNavigate } from 'react-router-dom';
import { SearchTabs } from '@/components/Hero/SearchTabs';

const Hero = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [activeTab, setActiveTab] = useState<'displays' | 'sequences'>('displays');
  const navigate = useNavigate();

  useEffect(() => {
    setIsLoaded(true);

    // Preload background image for smooth transitions
    const img = new Image();
    img.src = "https://images.unsplash.com/photo-1576692155415-95f820a2c4c1?q=80&w=2080";
  }, []);

  const handleNearMeClick = () => {
    navigate('/displays/map');
  };

  return (
    <section className="relative h-[90vh] flex items-center overflow-hidden">
      {/* Background Overlay */}
      <div className="absolute inset-0 bg-black/40 z-10"></div>
      
      {/* Background Image with lazy loading and blur animation */}
      <div 
        className={cn(
          "absolute inset-0 z-0 bg-cover bg-center bg-no-repeat transition-opacity duration-1000",
          isLoaded ? "opacity-100" : "opacity-0"
        )}
        style={{ 
          backgroundImage: `url('https://images.unsplash.com/photo-1576692155415-95f820a2c4c1?q=80&w=2080')`,
        }}
      />

      {/* Hero Content */}
      <div className="container z-20 px-6 md:px-10 max-w-6xl mx-auto">
        <div 
          className={cn(
            "flex flex-col items-start space-y-8 max-w-2xl transition-all duration-1000",
            isLoaded ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"
          )}
        >
          <div>
            <div className="inline-block bg-primary/90 backdrop-blur-xs text-white text-sm px-3 py-1 rounded-full mb-4">
              Discover Holiday Magic
            </div>
            <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight">
              {activeTab === 'displays' ? (
                <>
                  Find Spectacular Holiday <span className="text-green-500">Light Displays</span> Near You
                </>
              ) : (
                <>
                  Find Spectacular Holiday <span className="text-blue-500">Sequences</span>
                </>
              )}
            </h1>
          </div>
          
          <p className="text-white/90 text-lg md:text-xl max-w-xl">
            Explore, share, and discover amazing holiday light spectacles in your neighborhood. Connect with display creators and their synchronized light sequences.
          </p>

          <SearchTabs className="w-full max-w-lg" activeTab={activeTab} setActiveTab={setActiveTab} />

          <Button
            variant="outline"
            className="bg-white/10 text-white border-white/20 hover:bg-white/20 rounded-full"
            onClick={handleNearMeClick}
          >
            <MapPin size={18} className="mr-2" /> Displays Near Me
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
